import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackViewedRecent.meta';

export const useTrackViewedRecent = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedRecent = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackViewedRecent };
};
